import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const SampleDataAccess = () => {
  const [open, setOpen] = React.useState(true);
  const [scrolledToBottom, setScrolledToBottom] = React.useState(false);
  const [notificationOpen, setNotificationOpen] = React.useState(false); // state baru

  const handleAgree = () => {
    setOpen(false);
    window.open(
       "https://docs.google.com/forms/d/e/1FAIpQLSe5EgruUVAXEqDfI3IpPa4drPRqa6jnlH2p06vB9Ae2gmnBlA/viewform",
      // "#",
      "_blank"
    );
  };

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setScrolledToBottom(true);
    }
  };

  return (
    <div>
      {/* NDA Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="600 px" fullWidth>
        <DialogTitle>Non Disclosure Agreement</DialogTitle>
        <DialogContent dividers onScroll={handleScroll} style={{ maxHeight: "700px" }}>
           <Typography variant="body2" color="text.secondary">
        <div style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }}>
      <h1>NON-DISCLOSURE AGREEMENT</h1>
      <p>
        hereby agree to be bound by a non-disclosure agreement in the activities of Integrated Land Administration and Spatial Planning Project (ILASPP), hereinafter referred to as the Agreement, with the following provisions.
      </p>

      <h2>ARTICLE 1</h2>
      <p>
        The INFORMATION RECIPIENT shall maintain the confidentiality of all data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER. The INFORMATION RECIPIENT shall not disclose, reproduce, distribute, transfer, or provide such data to any third party in any form or by any means without the prior written consent of the INFORMATION PROVIDER.
      </p>

      <h2>ARTICLE 2</h2>
      <p>
        The INFORMATION RECIPIENT is prohibited from using any data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER for any purpose or in any manner other than in support of the execution of the activities of Integrated Land Administration and Spatial Planning Project (ILASPP).
      </p>

      <h2>ARTICLE 3</h2>
      <p>
        The INFORMATION RECIPIENT shall take all necessary measures to store, protect, and safeguard all data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER to prevent unauthorized access or control by third parties.
      </p>

      <h2>ARTICLE 4</h2>
      <p>
        In addition to the provisions of this Agreement, the INFORMATION RECIPIENT agrees to be bound by and comply with all applicable laws, regulations, and policies of the INFORMATION PROVIDER concerning the handling of confidential information.
      </p>

      <h2>ARTICLE 5</h2>
      <p>
        (1) The INFORMATION RECIPIENT shall delete all data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER upon the conclusion of the activities of Integrated Land Administration and Spatial Planning Project (ILASPP).<br />
        <br />(2) The INFORMATION RECIPIENT shall issue a written declaration confirming compliance with the obligations set forth in paragraph (1).<br /><br />
        (3) The written declaration as referred to in paragraph (2) must be signed by the INFORMATION RECIPIENT.
      </p>

      <h2>ARTICLE 6</h2>
      <p>
        The INFORMATION RECIPIENT is prohibited from utilizing any data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER.
      </p>

      <h2>ARTICLE 7</h2>
      <p>
        The INFORMATION RECIPIENT agrees to be fully liable for any loss or damage suffered by the INFORMATION PROVIDER as a result of: <br />
        <br /> a. Unauthorized disclosure of any data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER, without the written consent of the INFORMATION PROVIDER; and/or <br />
        <br /> b. Any violation of the terms of this Agreement committed by the INFORMATION RECIPIENT or its representatives.
      </p>

      <h2>ARTICLE 8</h2>
      <p>
      (1) The INFORMATION RECIPIENT shall notify the INFORMATION PROVIDER of any unauthorized use or disclosure of data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER, as well as any breach of this Agreement, no later than 24 hours from the time such incident is discovered.<br />
      <br />(2) The INFORMATION RECIPIENT shall take all necessary measures to assist the INFORMATION PROVIDER in regaining control over the data, documents, records, and/or information of any kind that is known or received, whether directly or indirectly, from the INFORMATION PROVIDER, as referred to in paragraph (1).
      </p>

      <h2>ARTICLE 9</h2>
      <p>
        This Agreement shall take effect as of the date of its execution and shall remain in force until it is declared no longer in effect by both the INFORMATION PROVIDER and the INFORMATION RECIPIENT.
      </p>
    </div>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>CANCEL</Button>
          <Button
            onClick={handleAgree}
            variant="contained"
            color="primary"
            disabled={!scrolledToBottom}
          >
            AGREE & CONTINUE TO ACCESS NON URBAN SAMPLE DATA
          </Button>
        </DialogActions>
      </Dialog>

      {/* Notification Dialog */}
      <Dialog open={notificationOpen} onClose={() => setNotificationOpen(false)}>
        <DialogTitle>Notice</DialogTitle>
        <DialogContent>
          <Typography>Sample data not available</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNotificationOpen(false)} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SampleDataAccess;
